import { omitBy } from 'es-toolkit'

import type { CoinSlug, LiveCoinMarket } from '@/types/coin'

// For the sake of performance, WS server uses abbreviated field names
export type RawCoinMarketMessage = Partial<{
  s: string // symbol
  t: number // timestamp
  p: number // usd_price
  p24: number // usd_price_change_24h
  v24: number // usd_volume_24h
  mc: number // usd_marketcap
}> & {
  slug: CoinSlug // unique key
}

export function transformRawCoinMarketMessage(
  rawCoinMarketMessage: RawCoinMarketMessage,
): LiveCoinMarket {
  const { s, p, p24, mc, v24, slug } = rawCoinMarketMessage
  return omitBy(
    {
      slug,
      symbol: s,
      usd_price: p,
      usd_marketcap: mc,
      usd_volume_24h: v24,
      usd_price_change_24h: p24,
    },
    // Omit unavailable values
    val => val === undefined || val === null,
  )
}
